const quizzes = {
    'Social Dynamics Quiz': {
        id: 'example quiz society',
        name: 'Social Dynamics Quiz',
        topicId: 'example 2',
        cardIds: ['society1', 'society2', 'society3', 'society4'],
        icon: 'https://static-assets.codecademy.com/skillpaths/react-redux/redux-quiz-app/statistics.svg',
        topicName: 'Society'
    },
    'Fantasy World Trivia': {
        id: 'example quiz fantasy',
        name: 'Fantasy World Trivia',
        topicId: 'example 2',
        cardIds: ['fantasy1', 'fantasy2', 'fantasy3', 'fantasy4'],
        icon: 'https://static-assets.codecademy.com/skillpaths/react-redux/redux-quiz-app/spade.svg',
        topicName: 'Fantasy'
    },
    'Nature Wonders Quiz': {
        id: 'example quiz nature',
        name: 'Nature Wonders Quiz',
        topicId: 'example 2',
        cardIds: ['nature1', 'nature2', 'nature3', 'nature4'],
        icon: 'https://static-assets.codecademy.com/skillpaths/react-redux/redux-quiz-app/tree.svg',
        topicName: 'Nature'
    },
    'Society and Culture Quiz': {
        id: 'society and culture quiz',
        name: 'Society and Culture Quiz',
        topicId: 'example 2',
        cardIds: ['society5', 'society6', 'society7', 'society8'],
        icon: 'https://static-assets.codecademy.com/skillpaths/react-redux/redux-quiz-app/statistics.svg',
        topicName: 'Society'
    },
    'Fantasy Adventure Quiz': {
        id: 'fantasy quiz adventure',
        name: 'Fantasy Adventure Quiz',
        topicId: 'example 2',
        cardIds: ['fantasy5', 'fantasy6', 'fantasy7', 'fantasy8'],
        icon: 'https://static-assets.codecademy.com/skillpaths/react-redux/redux-quiz-app/spade.svg',
        topicName: 'Fantasy'
    },
    'Fantasy Creatures Quiz': {
        id: 'fantasy creatures quiz',
        name: 'Fantasy Creatures Quiz',
        topicId: 'example 2',
        cardIds: ['fantasy9', 'fantasy10', 'fantasy11', 'fantasy12'],
        icon: 'https://static-assets.codecademy.com/skillpaths/react-redux/redux-quiz-app/spade.svg',
        topicName: 'Fantasy'
    },
    'Nature Landscapes Quiz': {
        id: 'nature landscapes quiz',
        name: 'Nature Landscapes Quiz',
        topicId: 'example 2',
        cardIds: ['nature5', 'nature6', 'nature7', 'nature8'],
        icon: 'https://static-assets.codecademy.com/skillpaths/react-redux/redux-quiz-app/tree.svg',
        topicName: 'Nature'
    },
    'Human Behavior Quiz': {
        id: 'human behavior quiz',
        name: 'Human Behavior Quiz',
        topicId: 'example 2',
        cardIds: ['society9', 'society10', 'society11', 'society12'],
        icon: 'https://static-assets.codecademy.com/skillpaths/react-redux/redux-quiz-app/statistics.svg',
        topicName: 'Society'
    },
    'Fantasy Realms Quiz': {
        id: 'fantasy realms quiz',
        name: 'Fantasy Realms Quiz',
        topicId: 'example 2',
        cardIds: ['fantasy13', 'fantasy14', 'fantasy15', 'fantasy16'],
        icon: 'https://static-assets.codecademy.com/skillpaths/react-redux/redux-quiz-app/spade.svg',
        topicName: 'Fantasy'
    },
    'Wildlife Quiz': {
        id: 'wildlife quiz',
        name: 'Wildlife Quiz',
        topicId: 'example 2',
        cardIds: ['nature9', 'nature10', 'nature11', 'nature12'],
        icon: 'https://static-assets.codecademy.com/skillpaths/react-redux/redux-quiz-app/tree.svg',
        topicName: 'Nature'
    },
    'Nature Secrets Quiz': {
        id: 'nature secrets quiz',
        name: 'Nature Secrets Quiz',
        topicId: 'example 2',
        cardIds: ['nature13', 'nature14', 'nature15', 'nature16'],
        icon: 'https://static-assets.codecademy.com/skillpaths/react-redux/redux-quiz-app/tree.svg',
        topicName: 'Nature'
    },
    'Social Norms Quiz': {
        id: 'social norms quiz',
        name: 'Social Norms Quiz',
        topicId: 'example 2',
        cardIds: ['society13', 'society14', 'society15', 'society16'],
        icon: 'https://static-assets.codecademy.com/skillpaths/react-redux/redux-quiz-app/statistics.svg',
        topicName: 'Society'
    },
};

export default quizzes;
